export default __webpack_public_path__ + "static/sbm-best-award-2024-360423796ebe4de1d2a18910eedd3002.png";